export const title = "어디로 갈까요?\n목적지를 선택해 주세요.";

export const buttonList = [
  {
    location_name: "한라산 등산로 입구",
    road_address: "제주특별자치도 제주시 한라산길 123",
    longitude: "126.533008",
    latitude: "33.361667",
  },
];
